/** Image item in a blog post media gallery. */
export interface BlogMediaImage {
  id: string;
  type: "image";
  path: string;
  alt?: string;
}

/** Video item (YouTube / Vimeo URL) in a blog post media gallery. */
export interface BlogMediaVideo {
  id: string;
  type: "video";
  url: string;
}

export type BlogMediaItem = BlogMediaImage | BlogMediaVideo;

export interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  body: string;
  is_published: boolean;
  created_at: string;
  updated_at: string;
  created_by: string | null;
  /** Storage path in blog-media bucket; null/undefined when unset */
  cover_image_path?: string | null;
  /** Ordered gallery of photos and embed videos */
  media?: BlogMediaItem[];
  /** Set when loaded in admin (from blog_post_view_counts); undefined on public list/detail */
  view_count_unique?: number;
  view_count_total?: number;
}

/** PostHog event/property names for blog analytics (used in multiple files). */
export const BLOG_ANALYTICS = {
  VIEWED_EVENT: "blog_post_viewed",
  POST_ID: "post_id",
  POST_TITLE: "post_title",
} as const;
